module.exports = __webpack_public_path__ + "static/VG5000-Regular_web-19df8794a5075ae43aa28d1edb582eb0.woff2";